var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatWindowVue"},[_c('chat-panel',{attrs:{"mode":"window"}}),_vm._v(" "),(!_vm.enabled)?_c('div',{staticClass:"cw__off"},[_vm._v("\n    Chat preview is not enabled in this build.\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }